import { batch } from 'editor/src/store/batchedSubscribeEnhancer';
import { setCalendarCountriesChosenByCustomerAction } from 'editor/src/store/design/slice';
import type { ThunkDispatch } from 'editor/src/store/hooks';
import { isEmbedded } from 'editor/src/store/watchers/useDisplayMode';

import requestCalendarCountriesOperation from './requestCalendarCountriesOperation';

const selectCalendarCountriesOperation = (countries: string[]) => (dispatch: ThunkDispatch) => {
  batch(() => {
    // The customer's own pick wins over their location. The merchant's switch stays on: it also
    // decides whether the customer sees the Calendar events tab at all.
    if (isEmbedded) {
      dispatch(setCalendarCountriesChosenByCustomerAction());
    }
    dispatch(requestCalendarCountriesOperation(countries));
  });
};

export default selectCalendarCountriesOperation;
